/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import InventoryService from '../inventory.service';
import { IAmiHead } from 'src/app/@amiga-pyme/components/ami-head/ami-head.interface';
import { Inventory } from '../inventory.interface';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { getTagColor } from 'src/helpers/tag-color.helpers';
// import { pipe } from 'rxjs';

@Component({
  selector: 'pg-inventory-document',
  templateUrl: './inventory-document.component.html'
})
export class InventoryDocumentComponent extends TableActionsTemplate {
  settingsAmiHead: IAmiHead = {
    title: 'Inventario',
    addressImg: 'reports'
  };

  constructor(private serviceBase: InventoryService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Reporte de inventario',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'productCode' },
        { header: 'Codigo de barras', field: 'productBarCode' },
        { header: 'Registro Sanitario', field: 'registerNumber' },
        { header: 'Nombre', field: 'productName', rowspan: true },
        { header: 'Formato', field: 'formato' },
        { header: 'Lote', field: 'lot' },
        {
          header: 'Vencimiento',
          field: 'expAt',
          exportField: 'expAtPeru',
          pipe: 'Date'
        },
        { header: 'Precio de venta', field: 'price', pipe: 'Currency' },
        {
          header: 'Precio de compra',
          field: 'purchasePrice',
          pipe: 'Currency'
        },
        { header: 'Stock', field: 'stock' },
        { header: 'Valorizado con IGV', field: 'valorized', pipe: 'Currency' },
        { header: 'IGV Compras', field: 'igv', pipe: 'Currency' },
        { header: 'Laboratorio', field: 'laboratory' },
        { header: 'Proveedor', field: 'providerName' }
      ],
      exportData: true,
      filterColumns: true
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: any[]) => {
        data = data.map((item) => {
          item.statusColor = getTagColor(item.status);
          item.expAtPeru = this.formatDateOnly(item.expAt);
          return item;
        });
        this.table.data = data;
      });
  }

  private formatDateOnly(value: string): string {
    if (!value) return '';

    const text = String(value);
    const dateWithSlashes = text.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (dateWithSlashes) {
      return `${dateWithSlashes[1]}/${dateWithSlashes[2]}/${dateWithSlashes[3]}`;
    }

    const dateWithHyphens = text.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (dateWithHyphens) {
      return `${dateWithHyphens[1]}/${dateWithHyphens[2]}/${dateWithHyphens[3]}`;
    }

    const isoDate = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDate) {
      return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return text;

    return new Intl.DateTimeFormat('es-PE', {
      timeZone: 'America/Lima',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
